import { render, staticRenderFns } from "./CompetitionDetailAward.vue?vue&type=template&id=64df409a&scoped=true&"
import script from "./CompetitionDetailAward.vue?vue&type=script&lang=js&"
export * from "./CompetitionDetailAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64df409a",
  null
  
)

export default component.exports